import React from "react"
import Radium from "higher-order-components/configured-radium"
import { BASE_HEADING } from "constants/general-style"
import COLOR_PALETTE from "constants/color-palette"

const TextVideoFrame = ({ children }) => (
  <div style={styles.wrapper}>
    <h1 style={styles.text}>{children}</h1>
  </div>
)

const styles = {
  wrapper: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "100%",
    margin: "0 auto"
  },
  text: {
    ...BASE_HEADING,
    color: COLOR_PALETTE.WHITE,
    fontSize: "400%",
    textAlign: "center",
    letterSpacing: "0.1em"
  }
}

export default Radium(TextVideoFrame)



// WEBPACK FOOTER //
// ./src/components/text-video-frame/index.jsx